export default __webpack_public_path__ + "static/media/honeymob1.4e388a30.webp";